module.exports = __webpack_public_path__ + "static/media/s6.d479f66b.jpg";